
import WithModel from '@/mixins/withModel';
import * as OM from '@/model';
import { JsonClone } from '@/utils';
import * as VM from '@/viewmodel';
import { mixins, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    emits: {
        add: ""
    }
})
export default class newCommentForm extends mixins(WithModel) {

    declare localValue: VM.AddCommentVm;

    tempFile: File = null;

    onDrop(ev){
        this.tempFile = ev.dataTransfer.files[0];
        this.addFile();
    }

    addComment(){
        if(!this.canSaveComment)
            return;

        this.$emit('add', this.localValue);

        this.localValue = new VM.AddCommentVm();
    }

    addFile(){
        this.localValue.fileList.push(this.tempFile);
        this.tempFile = null;
    }

    removeFile(item: File){
        let index = this.localValue.fileList.findIndex(x => x == item);
        this.localValue.fileList.splice(index, 1);
    }
    
    get canSaveComment(){
        return this.localValue.text || this.localValue.fileList.length > 0;
    }

}

